import { z } from 'zod';
import { clientDetailedSchema } from '../../GET/client/response';
import { id } from '../../common/atomic/id';

export const updateClientSchema = clientDetailedSchema
  .pick({
    firstName: true,
    lastName: true,
    title: true,
    sex: true,
    birthdate: true,
    phone: true,
    email: true,
    contacts: true,
    servAddress: true,
    permAddress: true,
  })
  .merge(z.object({ tags: z.array(id) }));

export type UpdateClient = z.infer<typeof updateClientSchema>;
